module.exports = __webpack_public_path__ + "static/media/resume.7a5c8e05.pdf";